import InventoryEditFloorplan from './InventoryEditFloorplan'
export default InventoryEditFloorplan
